import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { PostalAddressInput } from '#src/__generated__/globalTypes.ts';
import { PostalAddressForm } from '#src/components/settings/PostalAddressForm/index.tsx';
import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  UpdateUserPostalAddressMutation,
  UpdateUserPostalAddressMutationVariables,
} from './__generated__/useUpdateUserPostalAddress.graphql.ts';

const UPDATE_POSTAL_ADDRESS_MUTATION = gql`
  mutation UpdateUserPostalAddressMutation($input: updateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      currentUser {
        slug
        userSettings {
          id
          ...PostalAddressForm_userSettings
        }
      }
      errors {
        path
        message
        code
      }
    }
  }
  ${/* oxlint-disable-next-line sorare/no-detached-fragments */ ''}
  ${PostalAddressForm.fragments.userSettings}
` as TypedDocumentNode<
  UpdateUserPostalAddressMutation,
  UpdateUserPostalAddressMutationVariables
>;

export const useUpdateUserPostalAddress = () => {
  const [mutate] = useMutation(UPDATE_POSTAL_ADDRESS_MUTATION);

  return async (postalAddress: PostalAddressInput) =>
    mutate({
      variables: {
        input: {
          postalAddress,
        },
      },
    });
};
